/**
 * @generated SignedSource<<c4a026f377ec763b5678d3c4c78bb809>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteOccurrenceButtonFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "DeleteOccurrenceButtonFragment";
};
export type DeleteOccurrenceButtonFragment$key = {
  readonly " $data"?: DeleteOccurrenceButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteOccurrenceButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteOccurrenceButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Occurrence",
  "abstractKey": null
};

(node as any).hash = "fd66ebb26525ebe32fae89610ec21339";

export default node;
